<div class="col-11 col-sm-11 col-md-11 col-lg-11 col-xl-11 text-center m-auto  ">


  <!-- formulaire enrollement -->
  <div class="card"  style="padding: 10px;">
    <div class="d-flex justify-content-center">
      <h5 id="heading">Avis</h5>
      <button type="button"  class="btn btn-link position-absolute" style="top: 10px; right: 10px;" aria-label="Close" (click)="closeModal()">
        <i class="fas fa-times text-dark" style="font-size: 1.5rem; "></i>
      </button>
    </div>
   <!-- <p>Fill all form field to go to next step</p> -->
   <form  #form="ngForm" (ngSubmit)="onSubmit(form)" novalidate id="msform" >
       <!-- progressbar -->
       <ul id="progressbar">
           <li class="active" id="step1"><strong> </strong></li>
           <!-- <li id="step2"><strong>Informations recours</strong></li>
           <li id="step4"><strong>Piéces en jointes</strong></li> -->


       </ul>

       <fieldset  >
        <div class="d-flex flex-column">
          <div style="max-height: 500px;overflow-y: auto;">
            <div class="d-flex justify-content-between flex-column bg-dark text-light mb-2" >
              <div class="d-flex justify-content-between text-light mb-2  w-100">
                <label class="fieldlabels  text-light  m-auto" style="font-size: 15px;">Liste de mes avis</label>
              </div>
            </div>
            <ng-container *ngIf="list_avis.length > 0; else empty">
              <section *ngFor="let avis of list_avis" class="box mb-3 mt-2 d-flex justify-content-between">
                <span class="d-block text-start">
                  {{ avis.avis }}
                </span>
                <span>
                  {{formatDateTe(avis.modified)}}
                </span>
              </section>
            </ng-container>
            
            <ng-template #empty>
              <p class="text-muted text-center">Aucun avis disponible</p>
            </ng-template>
            
          </div>

          <div class="mt-3">
            <div class="float-left col-md-11" *ngIf="CAN_WRITE_AVIS">
              <div class="d-flex flex-wrap justify-content-center">
                <div class="col-md-8 col-sm-12">
                  <label class="fieldlabels">Méssage pour avis:</label>
                  <textarea style="height: 130px;" class="form-control" placeholder="Entrer les informations liées à votre avis" name="avis" ngModel></textarea>
                </div>&nbsp;&nbsp;
                <div class="col-md-3 col-sm-12 mt-3" *ngIf="opened_avis && opened_avis.length > 0">
                  <label class="fieldlabels">Destinataire:</label>
                  <select class="form-control" name="destinataire" ngModel>
                    <option value="">Sélectionner un destinataire</option>
                    <option *ngFor="let owner of owners" [value]="owner">{{owner}}</option>
                  </select>
                </div>
              </div>
          </div>
          </div>
        </div>

         <input *ngIf="CAN_WRITE_AVIS"  type="submit" class="action-button" value="Ajouter" />
        
       </fieldset>


   </form>


</div>
